import React, { useEffect, useState } from 'react'
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import lockIcon from "../../assets/Icons/lock.svg";
import { message } from '../../redux/actions/toastActions';
import { useDispatch } from 'react-redux';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';


const ChangePassword = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState({
        existing_password: "",
        password: "",
    });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false)
    const [showExistPassword, setShowExistPassword] = useState(false);

    const validate = () => {
        const newErrors = {};
        const password = data.password;

        const regex = {
            upper: /[A-Z]/,
            lower: /[a-z]/,
            number: /[0-9]/,
            special: /[!@#$%^&*]/,
        };
        if (!data.existing_password) {
            newErrors.existing_password = "Existing password is required.";
        }

        if (!data.password) {
            newErrors.password = "Password is required.";
        } else {
            if (data.password.length < 8 || data.password.length > 12) {
                newErrors.password = "Password must be 8–12 characters long.";
            } else if (!regex.upper.test(data.password)) {
                newErrors.password = "At least one uppercase letter required.";
            } else if (!regex.lower.test(data.password)) {
                newErrors.password = "At least one lowercase letter required.";
            } else if (!regex.number.test(data.password)) {
                newErrors.password = "At least one number required.";
            } else if (!regex.special.test(data.password)) {
                newErrors.password = "At least one special character required.";
            }
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = "Please confirm your password.";
        } else if (data.password !== confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match.";
        }

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) {
            dispatch(message("Please correct the highlighted errors."));
            return;
        }
        setLoader(true)
        let form = new FormData();
        form.append("password", data.existing_password)
        form.append("new_password", data.password)

        Postdata(HttpService.school_admin_change_password, form).then((res) => {
            if (res.status == 200) {
                setData({ existing_password: "", password: "" });
                setConfirmPassword("");
            }
            setLoader(false)
            dispatch(message(res.message))
        })
    }


    useEffect(() => {
        // Navigate to /settings with currentTab only once
        if (location?.state?.currentTab !== "Change Password") {
            navigate("/settings", {
                state: { currentTab: "Change Password" },
                replace: true,
            });
        }
    }, []);
    return (
        <div>
            <h2 className='text-3xl font-bold text-[#000000]'>Change Password</h2>
            <div className="p-6 space-y-6 pr-0">

                <form onSubmit={handleSubmit}>
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3'>

                        <div>
                            <label>
                                Existing Password<span className="required">*</span>
                            </label>
                            <div className="input-group">
                                <span className="icon">
                                    <img src={lockIcon} alt="lock icon" />
                                </span>
                                <input
                                    type={showExistPassword ? "text" : "password"}
                                    value={data.existing_password}
                                    autoComplete='off'
                                    onChange={(e) => setData({ ...data, existing_password: e.target.value })}
                                    placeholder="Enter Your Existing Password"

                                />
                                <span
                                    className="toggle"
                                    onClick={() => setShowExistPassword(!showExistPassword)}
                                >
                                    {showExistPassword ? (
                                        <IoEyeOffOutline className="icon" />
                                    ) : (
                                        <IoEyeOutline className="icon" />
                                    )}
                                </span>
                            </div>
                            {errors.existing_password && <p className="text-red-500 text-xs mt-1">{errors.existing_password}</p>}
                            <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
                        </div>
                        {/* Password */}
                        <div>
                            <label>
                                Password<span className="required">*</span>
                            </label>
                            <div className="input-group">
                                <span className="icon">
                                    <img src={lockIcon} alt="lock icon" />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={data.password}
                                    autoComplete='off'
                                    onChange={(e) => setData({ ...data, password: e.target.value })}
                                    placeholder="Enter Your Password"

                                />
                                <span
                                    className="toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? (
                                        <IoEyeOffOutline className="icon" />
                                    ) : (
                                        <IoEyeOutline className="icon" />
                                    )}
                                </span>
                            </div>
                            {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password}</p>}
                            <div className="mt-2 bg-gray-100  rounded-md text-sm text-gray-700">
                                <p className="font-semibold mb-2">A Strong Password should contain:</p>
                                <ul className="list-disc list-inside space-y-1">
                                    <li>8–12 characters</li>
                                    <li>At least One Uppercase letter (A–Z)</li>
                                    <li>At least One Lowercase letter (a–z)</li>
                                    <li>At least One Number (0–9)</li>
                                    <li>
                                        At least One Special character
                                        <span className="text-gray-500"> (e.g. @, #, $, !, %, &, *)</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Confirm Password */}
                        <div>
                            <label>
                                Confirm Password<span className="required">*</span>
                            </label>
                            <div className="input-group">
                                <span className="icon">
                                    <img src={lockIcon} alt="lock icon" />
                                </span>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm Your Password"

                                />
                                <span
                                    className="toggle"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                    {showConfirmPassword ? (
                                        <IoEyeOffOutline className="icon" />
                                    ) : (
                                        <IoEyeOutline className="icon" />
                                    )}
                                </span>
                            </div>
                            {errors.confirmPassword && <p className="text-red-500 text-xs mt-1">{errors.confirmPassword}</p>}

                        </div>
                    </div>
                    <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                        <button
                            type="submit"
                            className="button-field-primary"
                            style={{ width: "30%" }}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>

        </div>
    )
}

export default ChangePassword